import { h } from "preact";

import { useState, useEffect, useContext } from "preact/hooks";
import {

    Alert,
    Typography,
    Paper,
    Button,
    Box,

    Stack,

} from "@mui/material";

import { SessionContext } from "../../SessionContext";
import { AppContext } from "../../AppContext";
import Publicpage from "../PublicPage";
import { plain_fetch } from "../Common/functions";

export default function MakePublic({ id }) {
    const [state, setState] = useContext(SessionContext);

    const app = useContext(AppContext);

    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/0622fe92c03c4297ab3d5c00b0c56047/" + id, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        setState((state) => ({
                            ...state,
                            actualDeal: res.pld,
                        }));

                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    }, []);
    if (!state.actualDeal) return
    return (<div style={"margin: 10px"}>
        <Stack>
            <Alert
                style="padding: 10px; margin: 0px 10px 10px; box-shadow: 0px 0px 5px 0px red;"
                severity="warning"
                icon={false}
                action={<Box display="flex" justifyContent={"flex-end"}>
                    <Box p={1}>
                        <Button
                            variant="contained"
                            onClick={() =>
                                plain_fetch("/api/499d15eb724543c9bf7122c0bad1e72a/" + id, () => {
                                    window.location.href = "/11d1355181ac4376a09980601b420617/" + id;
                                })
                            }
                        >
                            Mettre en vente
                        </Button>
                        <Button
                            onClick={() => { window.location.href = "/11d1355181ac4376a09980601b420617/" + id; }
                            }>NON</Button>
                    </Box>
                    <Box p={1}></Box>

                </Box>
                }
            >
                <Box display="flex" justifyContent={"space-between"} alignItems="center">
                    <Box p={1}>
                        <Typography variant="h5">Voilà votre annonce :)</Typography>
                        <Typography variant="h5">Voulez-vous publier l'annonce suivante sur le site Bkeys ?</Typography>
                    </Box>
                    <Box p={1}>


                    </Box>

                </Box>


            </Alert>
            <Publicpage id={state.actualDeal.deal_uid} />
        </Stack>
    </div >)
}